import React from "react";
import PackageFormSearchTOF from "./Package-Form-Search-TOF";

class PackageHomeTop extends React.Component {
  render() {
    return (
      <div className="page-container">
        <div className="padideh-home-top">
          <PackageFormSearchTOF />
          <div
            onClick={() => this.props.handleLink()}
            className="adv-banner hidden-small hidden-xsmall hidden-medium margin-start-medium"
          ></div>
        </div>
      </div>
    );
  }
}

export default PackageHomeTop;
